// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/ona_intelligence.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/ona_intelligence.proto.
 */
export const file_gitpod_v1_ona_intelligence: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.CreateOrganizationLLMConfigurationRequest
 */
export type CreateOrganizationLLMConfigurationRequest = Message<"gitpod.v1.CreateOrganizationLLMConfigurationRequest"> & {
  /**
   * organization_id is the ID of the organization to configure
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * api_key is the plaintext Anthropic API key to encrypt and store
   *
   * @generated from field: string api_key = 2;
   */
  apiKey: string;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationLLMConfigurationRequest.
 * Use `create(CreateOrganizationLLMConfigurationRequestSchema)` to create a new message.
 */
export const CreateOrganizationLLMConfigurationRequestSchema: GenMessage<CreateOrganizationLLMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 0);

/**
 * @generated from message gitpod.v1.CreateOrganizationLLMConfigurationResponse
 */
export type CreateOrganizationLLMConfigurationResponse = Message<"gitpod.v1.CreateOrganizationLLMConfigurationResponse"> & {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;
};

/**
 * Describes the message gitpod.v1.CreateOrganizationLLMConfigurationResponse.
 * Use `create(CreateOrganizationLLMConfigurationResponseSchema)` to create a new message.
 */
export const CreateOrganizationLLMConfigurationResponseSchema: GenMessage<CreateOrganizationLLMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 1);

/**
 * @generated from message gitpod.v1.UpdateOrganizationLLMConfigurationRequest
 */
export type UpdateOrganizationLLMConfigurationRequest = Message<"gitpod.v1.UpdateOrganizationLLMConfigurationRequest"> & {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * api_key is the plaintext Anthropic API key to encrypt and store (optional)
   *
   * @generated from field: optional string api_key = 2;
   */
  apiKey?: string;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationLLMConfigurationRequest.
 * Use `create(UpdateOrganizationLLMConfigurationRequestSchema)` to create a new message.
 */
export const UpdateOrganizationLLMConfigurationRequestSchema: GenMessage<UpdateOrganizationLLMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 2);

/**
 * @generated from message gitpod.v1.UpdateOrganizationLLMConfigurationResponse
 */
export type UpdateOrganizationLLMConfigurationResponse = Message<"gitpod.v1.UpdateOrganizationLLMConfigurationResponse"> & {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;
};

/**
 * Describes the message gitpod.v1.UpdateOrganizationLLMConfigurationResponse.
 * Use `create(UpdateOrganizationLLMConfigurationResponseSchema)` to create a new message.
 */
export const UpdateOrganizationLLMConfigurationResponseSchema: GenMessage<UpdateOrganizationLLMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 3);

/**
 * @generated from message gitpod.v1.GetOrganizationLLMConfigurationRequest
 */
export type GetOrganizationLLMConfigurationRequest = Message<"gitpod.v1.GetOrganizationLLMConfigurationRequest"> & {
  /**
   * organization_id is the ID of the organization to query
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetOrganizationLLMConfigurationRequest.
 * Use `create(GetOrganizationLLMConfigurationRequestSchema)` to create a new message.
 */
export const GetOrganizationLLMConfigurationRequestSchema: GenMessage<GetOrganizationLLMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 4);

/**
 * @generated from message gitpod.v1.GetOrganizationLLMConfigurationResponse
 */
export type GetOrganizationLLMConfigurationResponse = Message<"gitpod.v1.GetOrganizationLLMConfigurationResponse"> & {
  /**
   * configuration contains metadata about the stored configuration
   *
   * @generated from field: gitpod.v1.OrganizationLLMConfiguration configuration = 1;
   */
  configuration?: OrganizationLLMConfiguration;
};

/**
 * Describes the message gitpod.v1.GetOrganizationLLMConfigurationResponse.
 * Use `create(GetOrganizationLLMConfigurationResponseSchema)` to create a new message.
 */
export const GetOrganizationLLMConfigurationResponseSchema: GenMessage<GetOrganizationLLMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 5);

/**
 * @generated from message gitpod.v1.ListOrganizationLLMConfigurationsRequest
 */
export type ListOrganizationLLMConfigurationsRequest = Message<"gitpod.v1.ListOrganizationLLMConfigurationsRequest"> & {
};

/**
 * Describes the message gitpod.v1.ListOrganizationLLMConfigurationsRequest.
 * Use `create(ListOrganizationLLMConfigurationsRequestSchema)` to create a new message.
 */
export const ListOrganizationLLMConfigurationsRequestSchema: GenMessage<ListOrganizationLLMConfigurationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 6);

/**
 * @generated from message gitpod.v1.ListOrganizationLLMConfigurationsResponse
 */
export type ListOrganizationLLMConfigurationsResponse = Message<"gitpod.v1.ListOrganizationLLMConfigurationsResponse"> & {
  /**
   * configurations is the list of organization LLM configurations
   *
   * @generated from field: repeated gitpod.v1.OrganizationLLMConfiguration configurations = 1;
   */
  configurations: OrganizationLLMConfiguration[];
};

/**
 * Describes the message gitpod.v1.ListOrganizationLLMConfigurationsResponse.
 * Use `create(ListOrganizationLLMConfigurationsResponseSchema)` to create a new message.
 */
export const ListOrganizationLLMConfigurationsResponseSchema: GenMessage<ListOrganizationLLMConfigurationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 7);

/**
 * @generated from message gitpod.v1.DeleteOrganizationLLMConfigurationRequest
 */
export type DeleteOrganizationLLMConfigurationRequest = Message<"gitpod.v1.DeleteOrganizationLLMConfigurationRequest"> & {
  /**
   * organization_id is the ID of the organization to delete configuration for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.DeleteOrganizationLLMConfigurationRequest.
 * Use `create(DeleteOrganizationLLMConfigurationRequestSchema)` to create a new message.
 */
export const DeleteOrganizationLLMConfigurationRequestSchema: GenMessage<DeleteOrganizationLLMConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 8);

/**
 * @generated from message gitpod.v1.DeleteOrganizationLLMConfigurationResponse
 */
export type DeleteOrganizationLLMConfigurationResponse = Message<"gitpod.v1.DeleteOrganizationLLMConfigurationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteOrganizationLLMConfigurationResponse.
 * Use `create(DeleteOrganizationLLMConfigurationResponseSchema)` to create a new message.
 */
export const DeleteOrganizationLLMConfigurationResponseSchema: GenMessage<DeleteOrganizationLLMConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 9);

/**
 * OrganizationLLMConfiguration contains metadata about an organization's LLM configuration.
 * For security reasons, the actual API key is never returned.
 *
 * @generated from message gitpod.v1.OrganizationLLMConfiguration
 */
export type OrganizationLLMConfiguration = Message<"gitpod.v1.OrganizationLLMConfiguration"> & {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * provider is the LLM provider (e.g., "anthropic")
   *
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * created_at is when the configuration was first created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the configuration was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.OrganizationLLMConfiguration.
 * Use `create(OrganizationLLMConfigurationSchema)` to create a new message.
 */
export const OrganizationLLMConfigurationSchema: GenMessage<OrganizationLLMConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 10);

/**
 * The organization is inferred from the caller's identity.
 * No parameters required.
 *
 * @generated from message gitpod.v1.GetOrganizationLLMUsageRequest
 */
export type GetOrganizationLLMUsageRequest = Message<"gitpod.v1.GetOrganizationLLMUsageRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetOrganizationLLMUsageRequest.
 * Use `create(GetOrganizationLLMUsageRequestSchema)` to create a new message.
 */
export const GetOrganizationLLMUsageRequestSchema: GenMessage<GetOrganizationLLMUsageRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 11);

/**
 * @generated from message gitpod.v1.GetOrganizationLLMUsageResponse
 */
export type GetOrganizationLLMUsageResponse = Message<"gitpod.v1.GetOrganizationLLMUsageResponse"> & {
  /**
   * usage_data_from is when usage tracking started for this organization
   * Typically when Ona Intelligence was enabled (organization_llm_integration.created_at)
   *
   * @generated from field: google.protobuf.Timestamp usage_data_from = 1;
   */
  usageDataFrom?: Timestamp;

  /**
   * last_calculated_at is when this usage data was last fetched and calculated
   * Helps users understand data freshness (typically 5-10 minutes behind real-time)
   *
   * @generated from field: google.protobuf.Timestamp last_calculated_at = 2;
   */
  lastCalculatedAt?: Timestamp;

  /**
   * this_week contains usage summary for the last 7 days
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_week = 3;
   */
  thisWeek?: LLMUsageSummary;

  /**
   * this_month contains usage summary for the last 30 days
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_month = 4;
   */
  thisMonth?: LLMUsageSummary;

  /**
   * this_year contains usage summary from Ona Intelligence activation to now (max 365 days)
   *
   * @generated from field: gitpod.v1.LLMUsageSummary this_year = 5;
   */
  thisYear?: LLMUsageSummary;
};

/**
 * Describes the message gitpod.v1.GetOrganizationLLMUsageResponse.
 * Use `create(GetOrganizationLLMUsageResponseSchema)` to create a new message.
 */
export const GetOrganizationLLMUsageResponseSchema: GenMessage<GetOrganizationLLMUsageResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 12);

/**
 * LLMUsageSummary contains aggregated LLM usage data for a specific time period
 *
 * @generated from message gitpod.v1.LLMUsageSummary
 */
export type LLMUsageSummary = Message<"gitpod.v1.LLMUsageSummary"> & {
  /**
   * credits_consumed is the total Ona credits consumed in this period
   *
   * @generated from field: double credits_consumed = 1;
   */
  creditsConsumed: number;

  /**
   * daily_breakdown contains per-day usage data for charting
   *
   * @generated from field: repeated gitpod.v1.DailyUsage daily_breakdown = 2;
   */
  dailyBreakdown: DailyUsage[];
};

/**
 * Describes the message gitpod.v1.LLMUsageSummary.
 * Use `create(LLMUsageSummarySchema)` to create a new message.
 */
export const LLMUsageSummarySchema: GenMessage<LLMUsageSummary> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 13);

/**
 * DailyUsage contains usage data for a single day
 *
 * @generated from message gitpod.v1.DailyUsage
 */
export type DailyUsage = Message<"gitpod.v1.DailyUsage"> & {
  /**
   * date is the start of the day (midnight UTC)
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * credits_consumed is the number of Ona credits consumed on this day
   *
   * @generated from field: double credits_consumed = 2;
   */
  creditsConsumed: number;
};

/**
 * Describes the message gitpod.v1.DailyUsage.
 * Use `create(DailyUsageSchema)` to create a new message.
 */
export const DailyUsageSchema: GenMessage<DailyUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_ona_intelligence, 14);

/**
 * OnaIntelligenceService manages organization-level LLM configurations for Ona Intelligence.
 * This service is restricted to Ona employees with the OnaIntelligenceAdmin role.
 *
 * @generated from service gitpod.v1.OnaIntelligenceService
 */
export const OnaIntelligenceService: GenService<{
  /**
   * Creates or updates the Anthropic API key configuration for an organization.
   *
   * Use this method to:
   * - Configure Anthropic API access for an organization
   * - Rotate existing API keys
   *
   * The API key is encrypted before storage using organization-scoped encryption.
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.CreateOrganizationLLMConfiguration
   */
  createOrganizationLLMConfiguration: {
    methodKind: "unary";
    input: typeof CreateOrganizationLLMConfigurationRequestSchema;
    output: typeof CreateOrganizationLLMConfigurationResponseSchema;
  },
  /**
   * Updates the Anthropic API key configuration for an organization.
   *
   * Use this method to:
   * - Update existing API key
   * - Modify configuration settings
   *
   * Only provided fields will be updated (partial update).
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.UpdateOrganizationLLMConfiguration
   */
  updateOrganizationLLMConfiguration: {
    methodKind: "unary";
    input: typeof UpdateOrganizationLLMConfigurationRequestSchema;
    output: typeof UpdateOrganizationLLMConfigurationResponseSchema;
  },
  /**
   * Gets metadata about the organization's LLM configuration.
   *
   * Use this method to:
   * - Check if an organization has an API key configured
   * - View when the key was last updated
   *
   * For security reasons, this method does not return the actual API key,
   * only metadata including the last 4 characters for identification.
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.GetOrganizationLLMConfiguration
   */
  getOrganizationLLMConfiguration: {
    methodKind: "unary";
    input: typeof GetOrganizationLLMConfigurationRequestSchema;
    output: typeof GetOrganizationLLMConfigurationResponseSchema;
  },
  /**
   * Lists all organization LLM configurations.
   *
   * Use this method to:
   * - View all organizations with LLM configurations
   * - Audit API key usage
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.ListOrganizationLLMConfigurations
   */
  listOrganizationLLMConfigurations: {
    methodKind: "unary";
    input: typeof ListOrganizationLLMConfigurationsRequestSchema;
    output: typeof ListOrganizationLLMConfigurationsResponseSchema;
  },
  /**
   * Deletes the organization's LLM API key configuration.
   *
   * Use this method to:
   * - Remove API key access for an organization
   * - Clean up unused configurations
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.DeleteOrganizationLLMConfiguration
   */
  deleteOrganizationLLMConfiguration: {
    methodKind: "unary";
    input: typeof DeleteOrganizationLLMConfigurationRequestSchema;
    output: typeof DeleteOrganizationLLMConfigurationResponseSchema;
  },
  /**
   * Gets credit usage summary for the caller's organization.
   *
   * The organization is inferred from the caller's identity.
   *
   * Use this method to:
   * - View Ona credit consumption for your organization
   * - Track usage over time
   * - Display usage data to organization admins
   *
   * Returns pre-aggregated summaries for week, month, and year.
   *
   * @generated from rpc gitpod.v1.OnaIntelligenceService.GetOrganizationLLMUsage
   */
  getOrganizationLLMUsage: {
    methodKind: "unary";
    input: typeof GetOrganizationLLMUsageRequestSchema;
    output: typeof GetOrganizationLLMUsageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_ona_intelligence, 0);

